import React, { Component, Fragment } from 'react';
import { dataList } from '../../../data/course/filter.js';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import Pagination from './../../../components/Pagination';
import DropdownSearch from '../../../components/searchDropdown';

class CourseItemGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            itemsPerPage: 10,
            selectedCountry: "",
            selectedCourse: "",
            selectedStream: ""
        };
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    };

    handleCountryChange = (value) => {
        this.setState({ selectedCountry: value, currentPage: 1 });
    };

    handleCourseChange = (value) => {
        this.setState({ selectedCourse: value, currentPage: 1 });
    };

    handleStreamChange = (value) => {
        this.setState({ selectedStream: value, currentPage: 1 });
    };

    render() {
        const { currentPage, itemsPerPage, selectedCountry, selectedCourse, selectedStream } = this.state;
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;

        // Filter dataList based on selected filters
        let filteredItems = dataList;
        if (selectedCountry) {
            filteredItems = filteredItems.filter(item => item.country === selectedCountry);
        }
        if (selectedCourse) {
            filteredItems = filteredItems.filter(item => item.study_level === selectedCourse);
        }
        if (selectedStream) {
            filteredItems = filteredItems.filter(item => item.category === selectedStream);
        }

        const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
        const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

        return (
          <Fragment>
            {/* Course Item */}
            <DropdownSearch
                selectedCountry={selectedCountry}
                selectedCourse={selectedCourse}
                selectStream={selectedStream}
                onCountryChange={this.handleCountryChange}
                onCourseChange={this.handleCourseChange}
                onStreamChange={this.handleStreamChange}
            />

            {filteredItems.length === 0 ? (
              <Col md="12" className="text-center" style={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <p style={{fontSize:20}}>No courses found matching the selected criteria.</p>
              </Col>
            ) : (
              <>
                {currentItems.map((data, i) => (
                  <Col lg="6" md="12" key={i}>
                    <div  className="course-item">
                      <Link to={process.env.PUBLIC_URL + data.courseLink}>
                        <div
                          className="course-image"
                          style={{
                                  backgroundImage: `url(${data.imgUrl})`,
                                  width: '100%',
                                  height:220
                                }}
                        >
                          {/* <div className="author-img d-flex">
                            <div className="img">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/${data.authorImg}`
                                }
                                alt=""
                              />
                            </div>
                            <div className="title">
                              <p>{data.authorName}</p>
                              <span>{data.authorCourses}</span>
                            </div>
                          </div> */}
                          {/* <div className="course-price">
                            <p>{data.price}</p>
                          </div> */}
                        </div>
                      </Link>
                      <div className="course-content">
                        <h6 className="heading" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          <Link to={process.env.PUBLIC_URL + data.courseLink} style={{textAlign:"left", display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color:"#192b49", fontWeight:"600" }}>
                            {data.courseTitle}
                          </Link>
                        </h6>
                        <p className="desc" 
                        style={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textAlign:"justify", marginTop:10, color:"#969696", fontSize:14 }}
                        >
                          {data.courseDesc}
                          </p>
                        {/* <div className="course-face d-flex justify-content-between">
                          <div className="duration">
                            <p>
                              <i className="las la-clock"></i>120
                            </p>
                          </div>
                          <div className="rating">
                            <ul className="list-unstyled list-inline">
                              <li className="list-inline-item">
                                <i className="las la-star"></i>
                              </li>
                              <li className="list-inline-item">
                                <i className="las la-star"></i>
                              </li>
                              <li className="list-inline-item">
                                <i className="las la-star"></i>
                              </li>
                              <li className="list-inline-item">
                                <i className="las la-star"></i>
                              </li>
                              <li className="list-inline-item">
                                <i className="las la-star-half-alt"></i>
                              </li>
                              <li className="list-inline-item">(4.5)</li>
                            </ul>
                          </div>
                          <div className="student">
                            <p>
                              <i className="las la-chair"></i>60
                            </p>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </Col>
                ))}

                <Col md="12" className="text-center">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={this.handlePageChange}
                  />
                </Col>
              </>
            )}
          </Fragment>
        );
    }
}

export default CourseItemGrid
